// extracted by mini-css-extract-plugin
module.exports = {"undoRedoIcon":"UndoRedo_undoRedoIcon__3zlI0"};